module.exports = __webpack_public_path__ + "static/media/bg-inicio-back.6188ceaa.png";